import React from 'react';

export default function PriceRange({ min, max, value, onChange }) {
  const lo = value?.lo ?? min;
  const hi = value?.hi ?? max;

  const handleLo = (e) => {
    let v = Number(e.target.value);
    if (v > hi) v = hi;
    onChange({ lo: v, hi });
  };
  const handleHi = (e) => {
    let v = Number(e.target.value);
    if (v < lo) v = lo;
    onChange({ lo, hi: v });
  };

  const pct = (v) => ((v - min) / (max - min)) * 100;

  return (
    <div>
      {/* اسلایدرها LTR تا «از/تا» و جای دسته‌ها درست باشد */}
      <div className="price-range" dir="ltr">
        <div className="track" />
        <div className="fill" style={{ left: `${pct(lo)}%`, width: `${pct(hi) - pct(lo)}%` }} />
        <input type="range" min={min} max={max} value={lo} onChange={handleLo} aria-label="حداقل قیمت" />
        <input type="range" min={min} max={max} value={hi} onChange={handleHi} aria-label="حداکثر قیمت" />
      </div>
      <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: '4px', fontSize: '0.85rem', color: 'var(--muted-fg)', direction: 'ltr' }}>
        <span>{Number(lo).toLocaleString('fa-IR')}</span>
        <span>{Number(hi).toLocaleString('fa-IR')}</span>
      </div>
    </div>
  );
}